import RestService from "../../../services/http-client";

export const loginHandler = async (username: string, password: string) => {
  const { data } = await RestService.send({
    serviceName: "login",
    body: {
      username,
      password,
    },
  });

  return data;
};

export const logoutHandler = async () => {
  await RestService.logout();
};